import React from "react";
import PropTypes from "prop-types";
import { Button } from "react-bootstrap";

const FunctionalButton = ({ variant, value, onClick, style, disabled }) => (
  <Button variant={variant} onClick={onClick} style={style} disabled={disabled}>
    {value}
  </Button>
);

FunctionalButton.propTypes = {
  variant: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  style: PropTypes.object.isRequired,
  onClick: PropTypes.func
};

FunctionalButton.defaultProps = {
  style: {},
};

export default FunctionalButton;
